import { useQuery } from "@apollo/client";

import { GqlPlannerV2ShiftsGetAllArgs } from "~/__generated__";

import { UserShiftsScreen_GetDataDocument } from "../queries.generated";

type Params = GqlPlannerV2ShiftsGetAllArgs & { userId: string };

export default function useUserShiftsScreen_GetData({ userId, ...rest }: Params) {
    const { data, previousData, loading, error } = useQuery(UserShiftsScreen_GetDataDocument, {
        variables: { params: { userId, ...rest }, userId },
    });

    const resolvedData = data ?? previousData;

    return {
        loading,
        error,
        data: resolvedData?.plannerV2ShiftGetAll.data,
        user: resolvedData?.userGetById,
    };
}
